var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7895 12.5263C17.7895 13.1579 17.3684 13.5789 16.7368 13.5789H6.62474C6.35952 13.5789 6.10517 13.6843 5.91763 13.8718L2 17.7895V3.05263C2 2.42105 2.42105 2 3.05263 2H16.7368C17.3684 2 17.7895 2.42105 17.7895 3.05263V12.5263ZM19.5729 5.15789H20.9321C21.5729 5.15789 22 5.57895 22 6.21053V22L17.7286 18.4181H7.27838C6.63767 18.4181 6.21053 17.997 6.21053 17.3655V16.1527C6.21053 15.6004 6.65824 15.1527 7.21053 15.1527H18.5729C19.1252 15.1527 19.5729 14.705 19.5729 14.1527V5.15789Z",
    fill: "#878793"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessages);
export default __webpack_public_path__ + "static/media/icon-messages.67ec81c675eeb840c9305e77aaef8cc6.svg";
export { ForwardRef as ReactComponent };